"use strict";
/**
 * Copyright (c) "Neo4j"
 * Neo4j Sweden AB [https://neo4j.com]
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeTransactionBody = exports.encodeAuthToken = exports.NEO4J_QUERY_CONTENT_TYPE = void 0;
exports.NEO4J_QUERY_CONTENT_TYPE = 'application/vnd.neo4j.query';
function encodeAuthToken(auth) {
    switch (auth.scheme) {
        case 'bearer':
            return "Bearer ".concat(auth.credentials);
        case 'basic':
            return "Basic ".concat(btoa("".concat(auth.principal, ":").concat(auth.credentials)));
        default:
            throw new Error("Authorization scheme \"".concat(auth.scheme, "\" is not supported."));
    }
}
exports.encodeAuthToken = encodeAuthToken;
function encodeTransactionBody(config) {
    var _a;
    var body = {};
    if ((config === null || config === void 0 ? void 0 : config.bookmarks) != null && !config.bookmarks.isEmpty()) {
        body.bookmarks = (_a = config === null || config === void 0 ? void 0 : config.bookmarks) === null || _a === void 0 ? void 0 : _a.values();
    }
    if ((config === null || config === void 0 ? void 0 : config.txConfig.timeout) != null) {
        body.maxExecutionTime = config === null || config === void 0 ? void 0 : config.txConfig.timeout.toInt();
    }
    if ((config === null || config === void 0 ? void 0 : config.impersonatedUser) != null) {
        body.impersonatedUser = config === null || config === void 0 ? void 0 : config.impersonatedUser;
    }
    if (config === null || config === void 0 ? void 0 : config.mode) {
        body.accessMode = config.mode.toUpperCase();
    }
    return body;
}
exports.encodeTransactionBody = encodeTransactionBody;
